import { c as o } from "../../_utils/cssr/index.js";
import f from "../common/_common.js";
const {
  cubicBezierEaseInOut: s
} = f;
function e({
  name: t = "fade-down",
  fromOffset: $ = "-4px",
  enterDuration: r = ".3s",
  leaveDuration: n = ".3s",
  enterCubicBezier: i = s,
  leaveCubicBezier: a = s
} = {}) {
  return [o(`&.${t}-transition-enter-from, &.${t}-transition-leave-to`, {
    opacity: 0,
    transform: `translateY(${$})`
  }), o(`&.${t}-transition-enter-to, &.${t}-transition-leave-from`, {
    opacity: 1,
    transform: "translateY(0)"
  }), o(`&.${t}-transition-leave-active`, {
    transition: `opacity ${n} ${a}, transform ${n} ${a}`
  }), o(`&.${t}-transition-enter-active`, {
    transition: `opacity ${r} ${i}, transform ${r} ${i}`
  })];
}
export {
  e as fadeDownTransition
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_styles/transitions/fade-down.cssr.js
// module id = 1616
// module chunks = 67